import React from 'react';

export const convertStringToJsx = (text: string): JSX.Element => {
  return <span>{text.split('').map((c, i) => (c === '\n' ? <br key={`br-${i}`} /> : c))}</span>;
};
